import { useModificationGroupHelperText as useSharedModificationGroupHelperText } from '@sg/shared-fe/features/customization';

import { useFeatureFlag } from '@order/LaunchDarkly';

export const useModificationGroupHelperText = () => {
  const isFreeAggregateMessageEnabled = useFeatureFlag(
    'CELS-4030-free-cyo-toppings-message-enabled',
  );

  return useSharedModificationGroupHelperText({
    isFreeAggregateMessageEnabled,
  });
};
